"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bboxOverlap = void 0;
function bboxOverlap(boundsA, boundsB) {
    return (boundsA[0] <= boundsB[2] &&
        boundsA[2] >= boundsB[0] &&
        boundsA[1] <= boundsB[3] &&
        boundsA[3] >= boundsB[1]);
}
exports.bboxOverlap = bboxOverlap;
